"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledWrapName = exports.StyledMessage = exports.StyledRotaTag = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledRotaTag = styled_components_1.default.div `
  justify-content: space-between;
  line-height: 12px;
  padding: 0px 16px;
  border: 1px solid #a1a1a1;
  border-radius: 20px;
  width: fit-content;
  max-width: 185px;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ isOrange, theme }) => isOrange ? theme.white : theme.primary.main};
  background-color: ${({ isOrange, theme }) => isOrange ? theme.primary.main : theme.white};
  :hover {
    border-color: ${({ theme }) => theme.primary.main};
    background-color: ${({ theme }) => theme.primary.main};
    color: ${({ theme }) => theme.white};
  }
`;
exports.StyledMessage = styled_components_1.default.p `
  font-family: Gotham A, Gotham B;
  font-size: 10px;
`;
exports.StyledWrapName = styled_components_1.default.span `
  font-family: Gotham A, Gotham B;
  font-size: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
  white-space: nowrap;
`;
